import Text from "components/Text";
import styled from "styled-components";
import theme from "../../theme";

export const Wrapper = styled.div`
    position: relative;
    background-color: ${theme.colors.background};
    min-height: 100vh;
    width: 100%;
    display: flex;

    .alimitless-logo {
        margin-left: 1rem;
    }
`;

export const LeftWrapper = styled.div`
    width: 50%;
    padding: 5rem 0;
    ${theme.mixins.flexCenter};

    @media (max-width: 767px) {
        width: 100%;
    }
`;

export const RightWrapper = styled.div`
    width: 50%;
    min-height: 100%;

    div:first-child {
        height: 100%;
    }

    @media (max-width: 767px) {
        display: none;
    }
`;

export const Card = styled.div`
    background-color: ${theme.colors.white};
    box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.05);
    border-radius: 20px;
    ${theme.mixins.flexCenter};
    flex-direction: column;
    align-items: center;
    row-gap: 1.2rem;
    width: 400px;
    padding: 1.8rem 0;
    transition: width 0.2s ease-in-out;

    @media (${theme.breakpoints.mobileL}) {
        margin: 0 0.5rem;
    }
`;

export const CompanyNameContainer = styled.div`
    position: absolute;
    left: 50px;
    bottom: 20px;
`;

export const CompanyName = styled.a`
    text-decoration: none;
    color: rgb(131, 76, 238);
`;

export const Form = styled.form`
    ${theme.mixins.flexCenter};
    flex-direction: column;
    align-items: flex-start;
    row-gap: 1.2rem;
    width: 100%;
    padding: 0 2.8rem;

    @media (${theme.breakpoints.mobileL}) {
        padding: 0 1rem;
    }
`;

export const Hr = styled.div`
    height: 1px;
    background-color: #efefef;
    width: 85%;
    margin: 0 auto;
`;

export const LogoWrapper = styled.a`
    ${theme.mixins.flexCenter};
    &:hover {
        cursor: pointer;
    }
    .alimitless-logo {
        margin-left: 1rem;
    }
    z-index: 10;
`;

export const CheckboxWrapper = styled.div`
    ${theme.mixins.flexCenter};
    line-height: 16px;
    transition: all 0.3s ease-in-out;
    a {
        margin-left: 0.3rem;
    }
`;

export const StepperWrapper = styled.div`
    padding: 0 2.8rem;
    width: 100%;
    text-align: center;
`;

export const StepTextWrapper = styled.div`
    padding-top: 1.2rem;
`;

export const ButtonsWrapper = styled.div`
    ${theme.mixins.flexCenter};
    width: 100%;
    column-gap: 1rem;
`;

export const InfoWrapper = styled.div`
    ${theme.mixins.flexCenter};
    column-gap: 1.5rem;
    width: 100%;
`;

export const InfoCard = styled.div<{
    checked: boolean;
}>`
    ${theme.mixins.flexCenter};
    flex-direction: column;
    height: 100px;
    width: 100px;
    border: 1px solid
        ${({ checked }) => (checked ? theme.colors.purple.primary : "#ECECEC")};
    border-radius: 8px;
    padding: 10px;
    row-gap: 0.2rem;

    svg {
        margin-bottom: 0.6rem;
        fill: ${({ checked }) =>
            checked ? theme.colors.purple.primary : "#8A8A8A"};
    }

    &:hover {
        cursor: pointer;
    }
`;

export const CommonWrapper = styled.div`
    width: 100%;
    padding: 0 9%;

    @media (${theme.breakpoints.mobileL}) {
        padding: 0 14px;
    }
`;

export const TermsAndConditionsLink = styled.a<{
    color?: string;
    hoverColor?: string;
    activeColor?: string;
    underline?: boolean;
}>`
    /* text-decoration-color: #8868ea; */
    ${Text.Style} {
        color: ${({ color }) => color || theme.link.color};
        /* text-decoration: ${({ underline }) =>
            underline ? "underline" : "none"}; */
    }
    &:active {
        ${Text.Style} {
            color: ${({ activeColor }) =>
                activeColor || theme.link.activeColor};
        }
    }
    &:hover {
        ${Text.Style} {
            color: ${({ hoverColor }) => hoverColor || theme.link.hoverColor};
            /* text-decoration: underline; */
            outline-width: 0;
            cursor: pointer;
        }
    }
`;
